import React, { useEffect, useState, useRef } from "react";
import "../../styles/landingpage.css";
import landingPageVideo from "../../assets/landingPage.mp4";
import fallbackImage from "../../assets/dtuBirdEyeView.jpg";
import Header from "../Website/HeaderLandingPage";

const LandingPage = ({ id }) => {
  const [isVideoPlaying, setIsVideoPlaying] = useState(true);
  const [showFallback, setShowFallback] = useState(false);
  const videoRef = useRef(null);

  const smoothScrollTo = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      window.scrollTo({ top: section.offsetTop, behavior: "smooth" });
    }
  };

  useEffect(() => {
    const fallbackTimer = setTimeout(() => {
      if (!videoRef.current || videoRef.current.readyState < 3) {
        setShowFallback(true);
      }
    }, 200);
    return () => clearTimeout(fallbackTimer);
  }, []);

  const handleVideoCanPlay = () => setShowFallback(false);
  const handleVideoError = () => setShowFallback(true);

  const toggleVideoPlayback = () => {
    if (videoRef.current) {
      isVideoPlaying ? videoRef.current.pause() : videoRef.current.play();
      setIsVideoPlaying(!isVideoPlaying);
    }
  };

  return (
    <div id={id} className="landing-container">
      {/* Fallback */}
      <img
        src={fallbackImage}
        alt="DTU Campus"
        className={`background-fallback ${showFallback ? "active" : ""}`}
      />

      {/* Video */}
      <video
        ref={videoRef}
        className="background-video"
        autoPlay
        loop
        muted
        playsInline
        onCanPlay={handleVideoCanPlay}
        onError={handleVideoError}
      >
        <source src={landingPageVideo} type="video/mp4" />
        <source
          src={landingPageVideo.replace(".mp4", ".webm")}
          type="video/webm"
        />
      </video>

      {/* Video Controls */}
      <button
        className="video-controls"
        onClick={toggleVideoPlayback}
        aria-label={isVideoPlaying ? "Pause video" : "Play video"}
      >
        {isVideoPlaying ? "❚❚" : "▶"}
      </button>

      <div className="video-overlay" />

      {/* Reusable Header */}
      <div className="overlay-content">
        <Header smoothScrollTo={smoothScrollTo} />

        {/* Hero Section */}
        <div className="hero-section">
          <div className="hero-text">
            <h1 className="headline">
              <span className="word">Delhi</span>
              <span className="word">Technological</span>
              <span className="word">University</span>
            </h1>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="scroll-indicator" aria-hidden="true">
          <div className="floating-arrow"></div>
          <span>Start Your Journey</span>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
